module.exports = __webpack_public_path__ + "static/media/right.7d306e0e.svg";